import config from 'config';
import { format, parse } from 'date-fns';
import type { LpQuery, OrderBy, Query, WhereFilter } from 'types/common';

export const toCamelCase = jsonObject => {
	var newO, origKey, newKey, value;
	if (jsonObject instanceof Array) {
		return jsonObject.map(function(value) {
			if (typeof value === 'object') {
				value = toCamelCase(value);
			}
			return value;
		});
	} else {
		newO = {};
		for (origKey in jsonObject) {
			if (jsonObject.hasOwnProperty(origKey)) {
				newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString();
				value = jsonObject[origKey];
				if (value instanceof Array || (value !== null && value.constructor === Object)) {
					value = toCamelCase(value);
				}
				newO[newKey] = value;
			}
		}
	}
	return newO;
};

export const capitalize = text => {
	return text && text[0].toUpperCase() + text.slice(1);
};

export const prune = data => {
	let copy = Object.assign({}, data);
	let keys = Object.keys(copy);
	for (let i = 0; i < keys.length; i++) {
		let key = keys[i];
		if (key.charAt(0) === key.charAt(0).toUpperCase()) {
			delete copy[key];
		}
	}
	return copy;
};

export const prepareLoopBackFilter = (filter, enablePaging = true) => {
	if (enablePaging) {
		let pageIdx = filter.pageIdx || 0;
		filter.skip = pageIdx * config.TABLE_PAGE_SIZE;
		filter.limit = config.TABLE_PAGE_SIZE;
	}
	delete filter.pageIdx;
	return filter;
};

export const parseFormatDate = (dateString, dateFormat = 'DD-MM-YYYY') => {
	if (!dateString) {
		return '';
	}
	format(parse(dateString), dateFormat);
};

export const isObjectEmpty = obj => {
	for (let key in obj) {
		if (obj.hasOwnProperty(key) && !!obj[key]) return false;
	}
	return true;
};

export const createLpQuery = (query: Query = {}): LpQuery => {
	let q = Object.assign({ whereFilter: [], orderBy: [], pageIndex: 0, pageSize: 100 }, query);
	let lpQuery = {};
	if (q.whereFilter.length > 0) {
		if (q.whereFilter) {
			lpQuery.where = {
				or: q.whereFilter.map(el => {
					return { [el.field]: el.value };
				})
			};
		}
	}
	if (q.pageIndex > 0) {
		lpQuery.skip = q.pageIndex * q.pageSize;
		lpQuery.limit = q.pageSize;
	}
	return lpQuery;
};

export const lpQueryToUrl = (query: LpQuery = {}): string => {
	return Object.keys(query).length > 0 ? `?filter=${JSON.stringify(query)}` : '';
};



// WEBPACK FOOTER //
// ./src/utilities/utilities.js